import { ChangeDetectionStrategy, Component, afterNextRender, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { EnumRouteName, LANG_SIGNAL } from '@lyricstream/shared';
import { AnalyticsConsentService } from '../../../core/services/analytics-consent.service';

/**
 * Bandeau de consentement aux statistiques détaillées (Google Analytics).
 * Monté une fois dans app.html. « Accepter » et « Refuser » ont le même poids visuel
 * (pas de refus caché derrière un lien, cf. Loi 25 / lignes directrices CNIL).
 */
@Component({
  selector: 'ls-consent-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslateModule],
  templateUrl: './consent-banner.component.html',
  styleUrl: './consent-banner.component.scss',
})
export class ConsentBannerComponent {
  protected readonly consent = inject(AnalyticsConsentService);
  private readonly langSignal = inject(LANG_SIGNAL, { optional: true });
  protected readonly routeName = EnumRouteName;

  constructor() {
    afterNextRender(() => this.consent.restore());
  }

  protected lang(): string {
    return this.langSignal?.() ?? 'fr';
  }
}
